import * as React from 'react';
export var TrackingContext = /*#__PURE__*/React.createContext({});